import { MatDialogConfig } from '@angular/material/dialog';

import { IInviteUserModel } from '../../invite-user/invite-user-model';

export const DEFAULT_INVITE_USER_DIALOG_CONFIG: MatDialogConfig<IInviteUserModel> = {
    autoFocus: false,
    restoreFocus: false,
    panelClass: 'ium-dialog'
};